<template>
  <div v-if="showActionBar" class="br-admin-item-actions">
    <div
      class="br-admin__frf-row"
      :class="{ 'br-admin__frf-row--rejected': isRejectSelected }"
    >
      <!-- Gordon 公共驳回框（与公司/产品审批同一组件） -->
      <div class="br-admin__frf-wrap">
        <FieldRejectionFeedback
          :value="reasonText"
          mode="admin"
          :rejected="isRejectSelected"
          :templates="templates"
          :actor="frfActor"
          :error="frfError"
          @input="onReasonInput"
          @clear-error="onClearError"
          @update:rejected="onRejectedUpdate"
        />
      </div>
      <button
        v-if="showProceedButton"
        type="button"
        class="br-admin__proceed-btn"
        :class="{ 'br-admin__proceed-btn--compact': isRejectSelected }"
        :disabled="processing"
        @click="onProceedClick"
      >
        {{ $t('lbl_EMPBE_BR_Admin_Proceed') }}
      </button>
    </div>
  </div>
</template>

<script>
import FieldRejectionFeedback from '@/components/FieldRejectionFeedback/FieldRejectionFeedback.vue';
import { BR_STATUS, getItemStatusCode, resolveBrRejectReason } from '../../../businessDocuments/utils/brDocument';
import { isBrAdminDraftBarMode } from '../utils/brAdmin';

export default {
  name: 'BrAdminItemActions',
  components: { FieldRejectionFeedback },
  props: {
    item: { type: Object, required: true },
    draft: { type: Object, default: null },
    processing: { type: Boolean, default: false },
    /** 本会话已处理过且驳回相关无新变化时禁用「处理」 */
    proceedLocked: { type: Boolean, default: false },
    /** FRF templates（GetRejectTemplatesByApprovalId，与公司/产品一致） */
    templates: { type: Array, default: () => [] },
    showDirectRejectBar: { type: Boolean, default: false },
    canChangeToReject: { type: Boolean, default: false },
    isLastInEffectApproved: { type: Boolean, default: false },
  },
  computed: {
    rejectBlocked() {
      return this.showDirectRejectBar
        && this.isLastInEffectApproved
        && !this.canChangeToReject;
    },
    isDraftBarMode() {
      return isBrAdminDraftBarMode(this.item);
    },
    showActionBar() {
      return this.isDraftBarMode || this.showDirectRejectBar;
    },
    isRejectSelected() {
      return !!this.draft?.rejectSelected;
    },
    /** 人工审批中(PA)默认显示；非待审默认隐藏，改草稿后显示 */
    showProceedButton() {
      return !this.proceedLocked;
    },
    reasonText() {
      return this.draft && this.draft.reasonText != null
        ? String(this.draft.reasonText)
        : '';
    },
    /** 有机器返回理由时显示操作人 AI */
    frfActor() {
      if (resolveBrRejectReason(this.item)) {
        return 'AI';
      }
      return '';
    },
    frfError() {
      if (this.draft?.reasonError) {
        return this.$t('lbl_EMPBE_BR_Admin_RejectReasonRequired');
      }
      return '';
    },
  },
  methods: {
    onRejectedUpdate(rejected) {
      // 单据已是「已驳回」：不允许点标题取消勾选（会藏起理由框，看起来像手输丢失）
      if (!rejected && getItemStatusCode(this.item) === BR_STATUS.REJECTED) {
        return;
      }
      if (rejected && this.rejectBlocked) {
        this.$emit('reject-last-blocked');
        return;
      }
      this.$emit('update:rejected', !!rejected);
    },
    onReasonInput(value) {
      this.$emit('update:reason', value == null ? '' : String(value));
    },
    onClearError() {
      this.$emit('clear-reason-error');
    },
    onProceedClick() {
      if (this.processing || this.proceedLocked) {
        return;
      }
      this.$emit('proceed');
    },
  },
};
</script>
